import { Grid } from '@mui/material';
import ConfigurationField from './ConfigurationField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../paymentsManagerConfiguration.constants';

const FolderConfigurationSection = ({
  form,
  fieldErrors,
  onChange,
  disabled,
}) => (
  <>
    <SectionHeader>Folder configuration</SectionHeader>
    <Grid
      container
      spacing={SECTION_GRID_SPACING}
      sx={{ mb: SECTION_BOTTOM_MARGIN }}>
      <Grid item xs={12} md={6}>
        <ConfigurationField
          name='outbound_path'
          label='Payments Manager outbound path'
          value={form.outbound_path}
          onChange={onChange}
          error={fieldErrors.outbound_path}
          tooltip='SFTP path where Payments Manager files are uploaded, for example /outbound/'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ConfigurationField
          name='inbound_path'
          label='Inbound acknowledgement/Zelle notification path'
          value={form.inbound_path}
          onChange={onChange}
          error={fieldErrors.inbound_path}
          tooltip='Shared SFTP path for ACK and Zelle notification files, for example /inbound/'
          disabled={disabled}
        />
      </Grid>
    </Grid>
  </>
);

export default FolderConfigurationSection;
